import { EmployeeRoleEnum } from '../../../../../../common/src/enums/employee-role.enum';
import { InviteStatusEnum } from '../../../../../../common/src/enums/invite-status.enum';
import { EmployeeStatusEnum } from '../../../../../../common/dist/angular/enums/employee-status.enum';

export class EmployeeUtils {

  static getEmployeeRole(employeeRole: EmployeeRoleEnum): string {
    switch (employeeRole) {
      case EmployeeRoleEnum.Accountant:
        return 'Comptable';
      case EmployeeRoleEnum.Admin:
        return 'Admin';
      case EmployeeRoleEnum.Owner:
        return 'Propriétaire';
    }
  }

  static inviteStatusGetText(status: InviteStatusEnum) {
    switch (status) {
      case InviteStatusEnum.Pending:
        return 'En Attente';
      case InviteStatusEnum.Accepted:
        return 'Acceptée';
      case InviteStatusEnum.Archived:
        return 'Suprimée';
    }
  }

  static getEmployeeStatusText(status: EmployeeStatusEnum) {
    switch (status) {
      case EmployeeStatusEnum.Active:
        return 'Actif';
      case EmployeeStatusEnum.Suspended:
        return 'Suspendu';
    }
  }
}
